<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>{{this.pageTitle}} </strong>           
          </div>  
          <div class="box">
               <div id="overlay" >
             <div class="loader"></div>
           </div>
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-card-body>
                <b-row> 
                 <b-col md="6">               
                    <b-form-group label="Deposit Amount"  label-size="sm"
                      :label-cols="5" > 
                        <input class="input" type="text" name="DepositAmt"  v-model="amount" v-validate="'required'" :class="{'form-control input': true, 'is-danger': errors.has('form-1.amount') }" placeholder="Enter Deposit Amount" @keypress="onlyNumber">
                        <span v-show="errors.has('form-1.amount')" class="help is-danger">{{ errors.first('form-1.amount') }}</span>                            
                    </b-form-group>  

                    <b-form-group label="Payment Mode"  label-size="sm"
                      :label-cols="5" > 
                       
                        <input type="radio" name="paymentmode"  id="myCheck"  v-on:change="paymentmode" v-model="paymentmode" v-bind:value="0" checked> <span>  BankTransfer</span>&nbsp;&nbsp;&nbsp;  
                        <input type="radio" name="paymentmode"  v-on:change="paymentmode"  id="myCheck"  v-model="paymentmode" v-bind:value="1"> <span>Cash Collectable</span >
                    </b-form-group>  

                    <b-form-group label="Receipt No" id="rno"  style="display:block;" label-size="sm"
                      :label-cols="5" > 
                        <input class="input" type="text" id="receiptno" name="Receiptno"  v-model="customer.Receiptno"  :class="{'form-control input ': true, 'is-danger': errors.has('form-1.Receiptno') }" placeholder="Enter Receipt No"  @keypress="nospace">
                       <span v-show="errors.has('form-1.Receiptno')" class="help is-danger">{{ errors.first('form-1.Receiptno') }}</span>
                    </b-form-group> 

                    <b-form-group label="Rider Name"  label-size="sm"
                      :label-cols="5" >                   
                      <v-select v-model="rider_name" :options="this.data1"  
                      placeholder="Select Rider Name" name="Rider Name" v-validate="'required'" :class="{ danger: errors.has('Rider Name') }">
                      </v-select>
                      <span v-show="errors.has('Rider Name')" class="danger">
                          {{ errors.first('Rider Name') }}
                      </span>    
                    </b-form-group>    

                    <footer class="text-right mr-2" >
                        <b-button type="submit" class="mr-4" size="md" variant="primary">Submit</b-button>
                        <b-button type="button" size="md" variant="danger" @click="clear">Clear</b-button>
                    </footer>
                 </b-col>
                 <b-col md="6">
                 </b-col>
               </b-row>
             </b-card-body>
            </form>          
            <b-row>
              <b-col md="12">
                <b-card-body>
                  <div id="CodAmountTable" >
                    <b-row>
                      <b-col md="6">
                      <table class="table table-responsive-sm table-bordered table-striped table-sm " border="1" v-for="data in bankamountdata" v-model="bankamountdata">
                        <tr>
                        <th style="text-align: center;" colspan="2">Bank Transfer Record - {{data.createdby}}</th>
                          </tr>
                          <tr>
                              <td style="width: 51%;">Total Pending Bank Amount  </td>
                              <td style="width: 25%;"> {{ data.banktranster_pending_amount }} </td>
                          </tr>
                          <!--  <tr>
                              <td style="width: 51%;">Total Pending Cash Amount</td>
                              <td style="width: 25%;"> {{ data.cash_pending_amount }} </td>
                          </tr> -->
                          <tr>
                              <td>Applied For Approval </td>
                              <td> {{ data.bankamountnotapproved }} </td>
                          </tr>
                          <tr>
                              <td>Approved Bank Amount </td>
                              <td> {{ data.bankamountapproved }} </td>
                          </tr>
                      </table>
                    </b-col>
                    <b-col md="6">
                      <table class="table table-responsive-sm table-bordered table-striped table-sm " border="1" v-for="data in cashamountdata" v-model="cashamountdata">
                        <tr>
                        <th style="text-align: center;" colspan="2">Cash Transfer Record - {{data.createdby}}</th>
                          </tr>
                          <tr>
                              <td style="width: 51%;">Total Pending Cash Amount  </td>
                              <td style="width: 25%;"> {{ data.cash_pending_amount }} </td>
                          </tr>
                          <tr>
                              <td>Applied For Approval </td>
                              <td> {{ data.cashamountnotapproved }} </td>
                          </tr>
                          <tr>
                              <td>Approved Cash Amount </td>
                              <td> {{ data.cashamountapproved }} </td>
                          </tr>
                      </table>
                    </b-col>
                    </b-row>
                  </div>

                  <b-row>
                      <b-col sm="12" class="text-right">
                      <p > <b>Total Records :<span style="color:red;">{{ this.totalRows}}</span></b> </p>
                      </b-col> 
                  </b-row>

                  <div id="CodshipmnetAmountReport">
                    <table class="table table-striped table-bordered" border="1" >
                      <thead>
                        <tr>
                          <th>Sr.No.</th> 
                          <th>Rider Name</th>
                          <th>Created By</th>
                          <th>Created Date</th>
                          <th>Amount</th>
                          <th>Receipt No</th>
                          <th>Mode Of Payment</th>
                          <th>Status</th>
                          <th>Updated By</th>
                          <th>Updated Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr  v-for="(value, firstIndex) in items">
                           <td>{{firstIndex+1}}</td> 
                           <td>{{ value.ridername }}</td>
                          <td>{{ value.created_by }}</td>
                          <td>{{ value.created_date }}</td>
                          <td>{{ value.deposit_amount }}</td>
                          <td>{{ value.receipt_no}}</td>
                           <td>{{ value.payment_mode }}</td>
                          <td>{{ (value.status==1)?'Approved':(value.status==0)?'NotApproved':'Rejected'}}</td>
                          <td>{{ value.updated_by }}</td>
                          <td>{{ value.updated_date }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                </b-card-body>
             </b-col>
            </b-row>            
          </div>
        </b-card>
      </b-col>       
    </b-row>
  </div>
</template>
<style>
.notification.is-success {
      background-color: green!important;
      width: 400px;
}
</style>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
export default {
  data: function() {
    return {
      pageTitle: 'COD Day Closure',
      items:[], 
      amount:null,
      totalRows: 0,
      customer: {}, 
      TodaysAmt : 0,
      Receiptno : 0,
      requested_amount: 0,
      paymentmode: 0,  
      bankamountdata: [],  
      cashamountdata:[],
      selected: {id: '0', label: 'Select Delivery Agent'},
      data1 :[],
      rider_name:null,
    }
  },
  created: function() {
    this.ridernamelist()
    this.displaydata()
    this.totalamountdetails()
  },
  methods: {
    
    validateForm(scope) {  
      this.$validator.validateAll(scope).then(result => {        
        if (result) {
                var depositeamount = this.amount; 
                // alert(depositeamount);
                if(( this.customer.Receiptno=="" || this.customer.Receiptno==undefined || this.customer.Receiptno==null)|| this.paymentmode=='0' && this.paymentmode=='1') 
                {

                  alert("Please insert Receiptno");

                  return false;

                }
                if(this.paymentmode=='0'){

                  // alert("000");
                if(parseInt(depositeamount) > parseInt(this.bankamountdata[0].banktranster_pending_amount)) 
                {
                  // alert("")

                 Utils.notify("Invalid!! Deposite Amount should not be greater then Total Amount", "error");

                  return false;

                }
                }
                else if(this.paymentmode=='1'){
                  // alert("1111");
                  if(parseInt(depositeamount) > parseInt(this.cashamountdata[0].cash_pending_amount)) 
                  {

                  Utils.notify("Invalid!! Deposite Amount should not be greater then Total Amount", "error");
                      
                    return false;

                  }
                }
                // if (this.rider_name == null) {
                //   alert("Please Enter Rider Name")
                // }
                document.getElementById("overlay").style.display = "block";
                      var userdata = localStorage.getItem('userData');
                      var userInfo = JSON.parse(userdata);

                      var sysemailid = `${userInfo.sysemailid}`;
                      const codPayload = {
                        deposit_amount:this.amount,
                        receipt_no:this.customer.Receiptno,
                        payment_mode:this.paymentmode,
                        deliveryagentmasterid : this.rider_name.key,
                        created_by:sysemailid,
                        hub_id:`${userInfo.pickuplocationmasterid}`,
                      }
                      console.log("codPayload",codPayload)
                      // return false
                      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/adddayclosureuser`,codPayload ).then(result => {
                        document.getElementById("overlay").style.display = "none";
                          if (result.body.returnmsg === "Successful") {
                              
                              this.customer.Receiptno='';
                              this.amount= '';
                              this.rider_name='';
                              Utils.notify("Added successfully!", "Successful");

                            }
                             this.totalamountdetails();
                            this.displaydata();

                      })
                      .catch(ex => {
                        console.log("error", ex);
                      });
        } else {
          Utils.notify("Please fill mandatory fields", "error");
        }
      })
    }, 

    displaydata: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
         const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
        sysemailid:`${userInfo.sysemailid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      };

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdayclosurelisting`,obj).then(result => {
            this.isBusy = !this.isBusy;
            if (result.body.returnmsg=== 'Successful') {
                this.items  = result.body.returnvalue;   
                this.totalRows = result.body.returnvalue.length;          
            }else{
             
              this.items  = [];
              this.totalRows = 0;               
             
            }
        }).catch(ex => {
            console.log('error-----', ex)
        });
    },

    totalamountdetails: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var sysemailid = `${userInfo.sysemailid}`;

        const amountobj = {
          sysemailid: sysemailid  ,
          hub_id:`${userInfo.pickuplocationmasterid}`,
           is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getdayclosurerecords`,amountobj).then(result => {
            //this.isBusy = !this.isBusy;
           
            if (result.body.returnmsg=== 'Successful') {
                this.bankamountdata  = result.body.returnvalue[0].DayclosureBankTransferrecords; 
                this.cashamountdata=result.body.returnvalue[0].DayclosureCashrecords; 
                // console.log("hhhhhh",this.cashamountdata);
                //console.log(this.amountdata[0].pending_amount);
              

            }else{
             
              this.bankamountdata  = [];
              this.cashamountdata=[];
              this.totalRows = 0;               
             
            }
        }).catch(ex => {
            console.log('error-----', ex)
        });
    },

    codCalculation : function(amount){
        if (amount != '') {
              var depositAmt = 0;
              if(this.customer.DepositAmt != ''){
                 depositAmt = this.customer.DepositAmt;
              }
              let TodaysTotalAmt = this.pending_amount;
              //if(parseFloat(TodaysTotalAmt) < parseFloat(depositAmt)){
              if(parseFloat(this.banktranster_pending_amount ) < parseFloat(amount)){
                  Utils.notify("Check deposite amount as it is more than Total amount", "error");
                //    this.$fire({
                //   text:"Check deposite amount as it is more than Total amount",
                //   type: "warning",
                //   timer: 30000
                // });
              }else if(parseFloat(this.cash_pending_amount ) < parseFloat(amount)){
                  Utils.notify("Check deposite amount as it is more than Total amount", "error");
                //    this.$fire({
                //   text:"Check deposite amount as it is more than Total amount",
                //   type: "warning",
                //   timer: 30000
                // });
              }
        }
    },

    onlyNumber : function($event){

      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
     
       if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 8) {
          $event.preventDefault();
       }
    },

    nospace : function($event){

          let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
          
          if (keyCode ==32) {
              $event.preventDefault();
          }
    },

    clear: function() {
        this.customer = {}
        this.amount=''; 
        this.errors.clear('form-1')
        this.selected = {id: '0', label: 'Select SR'};
    },

    ridernamelist: function() {
      var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        const deliveryagentobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          isactive: '1',
            hub_id:`${userInfo.pickuplocationmasterid}`,
             is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      
        }
    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, 
      deliveryagentobj).then(result => {
            this.data1 = result.body;
            // console.log('data',this.data1);
            var data = [];
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentfirstname+ '  '+srData.deliveryagentlastname+ ' - '+srData.deliveryagentmasterid
                });
              });
              this.data1 = data;
        }).catch(ex => {
            console.log('error-----', ex)
        });
    },

  },

  filters: {
      capitalize: function(value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    },
  }
};
</script>

